module.exports = __webpack_public_path__ + "static/improved-resolution-hero-4a892612bd716ed9edfcbf325f11f746.png";